<template>
  <div id="app">
    <electron-menu></electron-menu>
    <router-view></router-view>
  </div>
</template>

<script>
import ElectronMenu from './components/common/ElectronMenu.vue';
import useConfigStore from './store/configStore';


export default {
  name: 'App',
  components: { ElectronMenu },
  mounted() {
    this.initConfigAndElectron();
  },

  methods: {
    async initConfigAndElectron() {
      if (!this.adminConfigStore.isLoaded) {
        await this.adminConfigStore.loadAdminConfig()
      }
      // Electron 相关逻辑
      if (window.electronAPI) {
        const configStore = useConfigStore()
        configStore.setElectronMode(true)
        window.electronAPI.invoke('isFullScreen')
          .then(full => configStore.setFullScreen(full))
      }
    }
  },
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
